const LangCards = {
	"cards._title": ["MY CARDS", "THẺ CỦA TÔI"],
	"cards._mySuspendedCards": ["MY SUSPENDED CARDS", "THẺ ĐANG TẠM KHÓA"],
	"cards._addCard": ["(+) Add Card", "(+) Thêm thẻ"],
}

export default LangCards



// WEBPACK FOOTER //
// ./src/resources/pages/LangCards.js